import { render, staticRenderFns } from "./Visits.vue?vue&type=template&id=5ed7b04c&"
import script from "./Visits.vue?vue&type=script&lang=js&"
export * from "./Visits.vue?vue&type=script&lang=js&"
import style0 from "./Visits.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports